{
"FUEL-PLACES--PLACES": "Registered Locations",
"FUEL-PLACES--SELECT": "These locations can be registered through the web login. Select an address",
"FUEL-PLACES--SEARCH": "Search",
"FUEL-PLACES--NOT-FOUND": "No address found"
}